/**
 * authcontroller
 * sēž titullapā un dod ielogošanās-izlogošanās fīčas
 */
angular
  .module("myApp")
  .controller(
    "AuthController",
    function (
      $state,
      authentication,
      ngDialog,
      $scope,
      $q,
      $timeout,
      Dialog,
      Notification,
      ParolesAtjaunosana,
      ParolesNomaina
    ) {
      var dto
      $scope.dto = {
        username: void 0,
        password: void 0,
        error: void 0,
      }
      dto = $scope.dto
      this.logout = () => {
        authentication.logout()
      }
      this.popup_login = () => {
        $scope.modal = true
        ngDialog.open({
          template: "pages/auth/login_modal.html",
          className: "ngdialog-theme-plain",
          width: 500,
          scope: $scope,
          closeByDocument: false,
        })
      }
      this.auth_nzdis = () => {
        window.location = "/sso/nzdis"
      }
      this.lostpass = () => {
        var v
        v = {
          epasts: dto.username,
        }
        return Dialog.dialog("pages/auth/lostpass.html", v, { width: 500 }, (p) => {
          v.id = 1
          p = new ParolesAtjaunosana(v)
          return Dialog.finish(p, () => {
            Notification.success("Uz jūsu e-pastu tika nosūtīts e-pasts ar paroles atjaunošanas saiti.")
          })
        })
      }
      this.chpass = () =>
        Dialog.dialog("pages/auth/chpass.html", {}, { width: 500 }, (dto) => {
          if (dto.p_new !== dto.p_repeat) {
            dto.p_repeat = ""
            $timeout($(".js-password").focus())
            return $q.reject($scope.en ? "The passwords don't match" : "Atkārtoti ievadītā parole nesakrīt.")
          }
          dto.id = 1
          return Dialog.finish(new ParolesNomaina(dto), () => {
            Notification.success(
              $scope.en ? "The password was changed successfully." : "Parole nomainīta veiksmīgi."
            )
          })
        })
      this.login = () => {
        var r
        r = authentication.login(dto.username, dto.password)
        r.catch((e) => {
          dto.password = void 0
          dto.error = e.data
        })
        r.then(() => {
          ngDialog.closeAll()
        })
      }
      this.set_context = (ctx) => {
        authentication.set_context(ctx.code)
        return $state.go("app.home")
      }
      return this
    }
  )
  .controller(
    "PasswordResetController",
    function (
      $scope,
      $rootScope,
      $state,
      $timeout,
      $stateParams,
      Notification,
      ParolesNomainaKods,
      uuiData,
      authentication
    ) {
      $scope.dto = void 0
      uuiData.list(
        "paroles_koda_parbaude",
        $stateParams,
        (d) => {
          if (d.length > 0) {
            $rootScope.en = d[0].ir_angliski
            if (d[0].ir_derigs) {
              $scope.dto = d[0]
            } else {
              $scope.failed = true
              $scope.exception =
                "Šī koda izmantošanas termiņš ir beidzies. Ja vēlaties nomainīt paroli, lūdzu, atkārtoti pieprasiet jaunu kodu."
            }
          } else {
            $scope.failed = true
            $scope.exception = "Ievadītais kods nav korekts."
          }
        },
        (e) => {
          $scope.failed = true
          $scope.exception = e.data
        }
      )
      this.setPass = () => {
        var d
        $scope.dto.error = void 0
        if ($scope.dto.p_new !== $scope.dto.p_repeat) {
          $scope.dto.p_repeat = ""
          $timeout($(".js-password").focus())
          $scope.dto.error = $scope.en ? "The passwords don't match" : "Atkārtoti ievadītā parole nesakrīt."
          return
        }
        d = new ParolesNomainaKods({
          id: 1,
          epasts: $scope.dto.epasts,
          kods: $stateParams.kods,
          parole: $scope.dto.p_new,
        })
        return d.$save(
          () => {
            var ret
            Notification.success($scope.en ? "Password changed succesfully!" : "Parole nomainīta veiksmīgi!")
            ret = authentication.login($scope.dto.epasts, $scope.dto.p_new)
            return ret.then(() => $state.go("app.home"))
          },
          (e) => {
            $scope.dto.error = e.data
          }
        )
      }
      return this
    }
  )
